let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("cSj9q")).then(() => parcelRequire('8uomH'));